import { signalStore, withState } from '@ngrx/signals';
import { Direction } from '../../enum';
import { CheckPoint } from '../../model';
import { CheckPointService } from '../../services';
import { initialState, withCommonMethods, withCrudMethods } from '../../state';

const initState = initialState<CheckPoint>({ direction: Direction.ASC });
export const CheckPointStore = signalStore(
  withState(initState),
  withCrudMethods(CheckPointService),
  withCommonMethods()
);
